import { SvgIcon } from 'ui/icons';

export const Campaigns = () => (
  <SvgIcon height="128" width="128" viewBox="0 0 128 128">
    <g clipPath="url(#clip0)">
      <path
        d="M115.84 71.808C115.84 64.1676 114.129 56.6242 110.834 49.7309C107.539 42.8377 102.742 36.7693 96.797 31.9706C90.8515 27.172 83.9074 23.7649 76.4739 21.999C69.0403 20.2332 61.3058 20.1534 53.8374 21.7655C46.3691 23.3776 39.3561 26.6407 33.3129 31.3156C27.2696 35.9905 22.3492 41.9586 18.9125 48.7824C15.4758 55.6063 13.6098 63.1127 13.4514 70.7515C13.2931 78.3902 14.8463 85.9676 17.9972 92.928H111.284C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.0801 92.9282H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32031 92.9282H11.5203"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.48 92.9282H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.91 104.96C95.91 106.24 81.83 107.392 64.3324 107.392C46.8348 107.392 32.7676 106.304 32.7676 104.96C32.7676 103.616 46.8476 102.528 64.3324 102.528C81.8172 102.528 95.91 103.68 95.91 104.96Z"
        fill="#F5F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.334 55.667H86.6673C91.0856 55.667 94.6673 59.2487 94.6673 63.667V85.0003C94.6673 86.4731 93.4734 87.667 92.0006 87.667H49.334"
        fill="#B56DC6"
      />
      <path
        d="M41.334 55.667H86.6673C91.0856 55.667 94.6673 59.2487 94.6673 63.667V85.0003C94.6673 86.4731 93.4734 87.667 92.0006 87.667H49.334"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.334 87.667H36.0007C34.5279 87.667 33.334 86.4731 33.334 85.0003V63.667C33.334 59.2487 36.9157 55.667 41.334 55.667C45.7523 55.667 49.334 59.2487 49.334 63.667V87.667Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M68 87.667V103.667" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M62.668 87.667V103.667"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.0013 103.667C68.0011 105 62.6682 105 62.668 103.667C62.6678 102.334 62.668 87.667 62.668 87.667H68.0013C68.0013 87.667 68.0015 102.334 68.0013 103.667Z"
        fill="#FDF5FF"
        stroke="#6A266D"
      />
      <path
        d="M38.668 82.334H44.0013"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M54.668 61L62.668 61Z" fill="#E6FBFF" />
      <path
        d="M54.668 61L62.668 61"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68 61L68 69L62.6667 69L62.6667 61L68 61Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.0411 44.7058C78.3956 45.5549 79.9446 46.044 81.5411 46.1268C85.8791 46.4598 87.5411 45.4578 88.1731 44.7538C88.2832 44.6329 88.3272 44.4658 88.2909 44.3063C88.2546 44.1469 88.1427 44.0152 87.9911 43.9538C86.4041 43.1835 84.911 42.2333 83.5411 41.1218C83.2041 40.8678 82.6681 40.4398 82.2021 40.0688C82.0663 39.961 81.996 39.7906 82.0164 39.6184C82.0368 39.4463 82.1449 39.2969 82.3021 39.2238C85.6521 37.6738 87.8121 34.5968 88.4411 30.3338C88.4665 30.1617 88.4007 29.9888 88.2672 29.8772C88.1338 29.7656 87.952 29.7314 87.7871 29.7868C86.0621 30.3648 81.9331 31.8598 81.5381 33.0428C81.1671 34.1568 80.2441 36.3428 79.7931 37.4008C79.7323 37.5425 79.6095 37.6481 79.4604 37.6872C79.3113 37.7263 79.1526 37.6944 79.0301 37.6008C77.7334 36.454 76.1996 35.6075 74.5381 35.1218C73.6811 34.9015 72.7704 35.0992 72.0819 35.6551C71.3935 36.211 71.0083 37.0596 71.0431 37.9438C71.0363 38.0548 70.9926 38.1604 70.9191 38.2438C70.5953 38.588 70.4145 39.0423 70.4131 39.5148C70.4124 39.6708 70.4845 39.8181 70.6081 39.9132C70.7316 40.0083 70.8925 40.0404 71.0431 39.9998L72.5431 39.6248"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.7998 37.127C73.9379 37.127 74.0498 37.2389 74.0498 37.377C74.0498 37.515 73.9379 37.627 73.7998 37.627C73.6617 37.627 73.5498 37.515 73.5498 37.377C73.5495 37.3106 73.5758 37.2468 73.6227 37.1999C73.6697 37.1529 73.7334 37.1267 73.7998 37.127"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.4395 36.3724C77.4395 36.3724 76.9395 32.3724 76.9395 30.3724C76.9395 29.2444 78.9185 26.9864 79.9005 25.9344C80.0199 25.8066 80.1974 25.7506 80.3685 25.7866C80.5397 25.8226 80.6796 25.9454 80.7375 26.1104C81.2062 27.4822 81.8989 30.8745 81.8936 32.3242"
        fill="#FDF5FF"
      />
      <path
        d="M77.4395 36.3724C77.4395 36.3724 76.9395 32.3724 76.9395 30.3724C76.9395 29.2444 78.9185 26.9864 79.9005 25.9344C80.0199 25.8066 80.1974 25.7506 80.3685 25.7866C80.5397 25.8226 80.6796 25.9454 80.7375 26.1104C81.2062 27.4822 81.8989 30.8745 81.8936 32.3242L79.5 37.5L77.4395 36.3724Z"
        fill="#FDF5FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.4395 36.3724C77.4395 36.3724 76.9395 32.3724 76.9395 30.3724C76.9395 29.2444 78.9185 26.9864 79.9005 25.9344C80.0199 25.8066 80.1974 25.7506 80.3685 25.7866C80.5397 25.8226 80.6796 25.9454 80.7375 26.1104C81.2062 27.4822 81.8989 30.8745 81.8936 32.3242"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.4395 36.3724C77.4395 36.3724 76.9395 32.3724 76.9395 30.3724C76.9395 29.2444 78.9185 26.9864 79.9005 25.9344C80.0199 25.8066 80.1974 25.7506 80.3685 25.7866C80.5397 25.8226 80.6796 25.9454 80.7375 26.1104C81.2062 27.4822 81.8989 30.8745 81.8936 32.3242L79.5 37.5L77.4395 36.3724Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.3086 46.1929L83.5456 48.0479"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.2148 46.0513L86.5458 48.0483"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.0459 40.627L76.5459 41.127L74.0459 46.627L65.5459 44.627L68.0459 39.127L70.4709 39.733"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.0459 39.127L70.5459 43.127L76.5459 41.127"
        fill="#E6FBFF"
      />
      <path
        d="M68.0459 39.127L70.5459 43.127L76.5459 41.127"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="128" height="128" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
